import getCDNImagePath from 'kerberus-components/src/Utils/getCDNImagePath';

interface BuildPopupParams {
    address?: string;
    image?: string;
    joined?: boolean;
    loading?: boolean;
    name: string;
    typeLabel?: string;
}

export function buildInstancePopupHTML({ address, image, joined, loading, name, typeLabel }: BuildPopupParams): string {
    const imagePath = image ? getCDNImagePath(image) : '';
    const escapeHtml = (s: string | undefined): string => {
        if (!s) {
            return '';
        }
        return s.replaceAll(/[&<>"]/g, (c) => ({ '"': '&quot;', '&': '&amp;', '<': '&lt;', '>': '&gt;' })[c] || c);
    };
    return `<div style="display:flex;flex-direction:column;align-items:stretch;min-width:120px;max-width:180px;box-sizing:border-box;gap:6px;">
  ${imagePath ? `<div style="position:relative;width:100%;aspect-ratio:16/9;overflow:hidden;border-radius:8px;border:1px solid #ddd;background:#f5f5f5;"><img src="${imagePath}.webp" alt="Instance" style="width:100%;height:100%;object-fit:cover;display:block;" /></div>` : ''}
  <div style="font:12px/1.45 system-ui,sans-serif;display:flex;flex-direction:column;gap:4px;">
    <div style="font-weight:600;font-size:13px;">${escapeHtml(name)}</div>
    ${typeLabel ? `<div style="color:#555;font-size:11px;">${escapeHtml(typeLabel)}</div>` : ''}
    ${address ? `<div style="color:#666;font-size:11px;white-space:normal;word-break:break-word;">${escapeHtml(address)}</div>` : ''}
    <div style="font-size:11px;color:${joined ? '#1C4E71' : '#9e9e9e'};">${joined ? 'Joined' : 'Not joined'}</div>
    ${loading ? '<div style="font-size:10px;color:#999;">Loading...</div>' : ''}
  </div>
</div>`;
}
